import { Box, Grid } from "@mui/material"
import { theme } from "src/providers/ThemeProvider"
import { Dialog, Text } from "src/shared"
import { GiftExchangeHistoryModel } from "src/types"

interface IQRCodeDialogProps {
  open?: boolean
  onClose: () => void
  data?: GiftExchangeHistoryModel
}

const QRCodeDialog = ({ open = false, onClose, data }: IQRCodeDialogProps) => {
  const onDialogClose = () => onClose()

  return (
    <Dialog disablePortal open={open} onClose={onDialogClose}>
      <Grid container alignItems="center" direction="column">
        <Text
          fontWeight={700}
          fontSize={30}
          lineHeight="39px"
          textTransform="uppercase"
          sx={theme => ({
            color: theme.palette.secondary.main,
          })}
        >
          Mã đổi quà
        </Text>
        <Text lineHeight="21px" color={theme.palette.grey[400]} fontSize={16}>
          Đưa mã này cho thu ngân
        </Text>
        <Text
          fontSize={24}
          fontWeight={700}
          mt={1}
          textAlign="center"
          sx={theme => ({
            color: theme.palette.info.main,
            lineHeight: "31.65px",
          })}
        >
          {data?.OrderCode}
        </Text>
        {data?.BarCodeImage && (
          <Box mt={2} width="100%" height={68}>
            <img
              src={`${process.env.REACT_APP_SEY_QR_CODE_URL}${
                data?.BarCodeImage || ""
              }`}
              alt="bar_code_image"
              width="100%"
              height="100%"
            />
          </Box>
        )}
        <Box mt={1.5} width={200} height={200}>
          <img
            width="100%"
            height="100%"
            src={`${process.env.REACT_APP_SEY_QR_CODE_URL}${
              data?.QrCodeImage || ""
            }`}
            alt="qr_code"
          />
        </Box>
      </Grid>
    </Dialog>
  )
}

export default QRCodeDialog
